import { BrowserRouter, Route, Routes } from "react-router-dom";
import React, { ReactElement, useEffect } from "react";
import {
  Aree,
  Dashboard,
  EscapeTower,
  FAQ,
  Food,
  Home,
  Login,
  Programma,
  RadunoGenshin,
  TalesPark,
  Tornei,
} from "../ui/pages";
import { ROUTES } from "../utils/constants";
import { theme } from "../ui/theme";
import { ChakraProvider } from "@chakra-ui/react";
import ProtectedRoute from "./ProtectedRoute";
import useSponsors from "../utils/hooks/useSponsors";
import useSiteState from "../utils/hooks/useSiteState";
import WrapperRoute from "./WrapperRouter";
import ReactGA from "react-ga";
const TRACKING_ID = "G-V0T2KD6F9C";
ReactGA.initialize(TRACKING_ID);

const AppRouter = (): ReactElement => {
  useSiteState();
  useSponsors();

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <ChakraProvider theme={theme} resetCSS>
      <BrowserRouter>
        <Routes>
          <Route element={<WrapperRoute />}>
            <Route path={ROUTES.HOME} element={<Home />} />
            <Route path={ROUTES.AREE} element={<Aree />} />
            <Route path={ROUTES.FOOD} element={<Food />} />
            <Route path={ROUTES.ESCAPE_TOWER} element={<EscapeTower />} />
            <Route path={ROUTES.TORNEI} element={<Tornei />} />
            <Route path={ROUTES.RADUNO_GENSHIN} element={<RadunoGenshin />} />
            <Route path={ROUTES.TALES_PARK} element={<TalesPark />} />
            <Route path={ROUTES.FAQ} element={<FAQ />} />
            <Route path={ROUTES.PROGRAMMA} element={<Programma />} />
          </Route>
          <Route path={ROUTES.ADMIN_LOGIN} element={<Login />} />
          <Route element={<ProtectedRoute />}>
            <Route path={ROUTES.ADMIN_DASHBOARD} element={<Dashboard />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ChakraProvider>
  );
};

export default AppRouter;
